import { Provider } from "react-redux";
import { store } from "@/store/store.ts";
import { FC, ReactNode } from 'react';

interface IProviders {
  children: ReactNode
}
export const Providers:FC<IProviders> = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};